import React from 'react';

export const ConfigTableContext = React.createContext();

export const useConfigTableContext = () => React.useContext(ConfigTableContext);
